<template>
	<ValidationObserver
		tag="form"
		v-slot="{ handleSubmit }"
		@submit.prevent
	>
		<section class="form-col">
			<h3 class="form-legend font-size-h3 bb-1 pb-1 mb-4">{{ $content.deliveryData }}:</h3>
			<div class="pl-6 pr-6 form">
				<div class="form-row">

					<div class="form-field form-required mb-4">
						<label for="deliveryFirstName" class="label">{{ $content.first_name }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliveryFirstName" name="firstName" class="form-control" type="text"
										 v-model="deliveryFirstName"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div class="form-field form-required mb-4">
						<label for="deliveryLastName" class="label">{{ $content.last_name }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliveryLastName" name="lastName" class="form-control" type="text"
										 v-model="deliveryLastName"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div class="form-field mb-4">
						<label for="deliveryCompanyName" class="label">{{ $content.company_name }}:</label>
						<input id="deliveryCompanyName" class="form-control" type="text"
									 v-model="deliveryCompanyName" />
					</div>

					<div class="form-field mb-4">
						<label for="deliveryPhoneNumber" class="label">{{ $content.phone }}:</label>
						<ValidationProvider rules="phone" v-slot="{ errors }">
							<input id="deliveryPhoneNumber" name="phoneNumber" class="form-control" type="tel"
										 v-model="deliveryPhoneNumber"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>
				</div>

				<div class="form-row">
					<div class="form-field form-required mb-4">
						<label for="deliveryStreet" class="label">{{ $content.street }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliveryStreet" name="street" class="form-control" type="text"
										 v-model="deliveryStreet"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div class="form-field form-required mb-4">
						<label for="deliveryStreetNumber" class="label">{{ $content.street_number }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliveryStreetNumber" name="streetNumber" class="form-control" type="text"
										 v-model="deliveryStreetNumber"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div class="form-field mb-4">
						<label for="deliveryApartmentNumber" class="label">{{ $content.apartment_number }}:</label>
						<input id="deliveryApartmentNumber" name="streetNumber" class="form-control" type="text"
									 v-model="deliveryApartmentNumber"/>
					</div>

					<div class="form-field form-required mb-4">
						<label for="deliveryZipCode" class="label">{{ $content.zip_code }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliveryZipCode" name="zipCode" class="form-control" type="text"
										 v-model="deliveryZipCode"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div class="form-field form-required mb-4">
						<label for="deliverCity" class="label">{{ $content.city }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<input id="deliverCity" name="city" class="form-control" type="text"
										 v-model="deliveryCity"/>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>

					<div v-if="$store.state.selectedPlan.is_abroad" class="form-field form-required">
						<label for="deliverCountry" class="label mb-1">{{ $content.country }}:</label>
						<ValidationProvider rules="required" v-slot="{ errors }">
							<v-select
								id="deliverCountry"
								v-model="deliveryCountry"
								:options="$store.state.countriesArr"></v-select>
							<p class="form-error">{{ errors[0] }}</p>
						</ValidationProvider>
					</div>
				</div>

				<div class="flex flex-justify-center btn-group mt-3">
					<button type="submit" @click="handleSubmit(onSubmit)" class="btn btn-primary btn-max">{{ $content.next }}</button>
				</div>
			</div>
		</section>
	</ValidationObserver>
</template>

<script>
	import { ValidationProvider, ValidationObserver } from 'vee-validate';
	import { mapGetters } from 'vuex';

	export default {
		name: 'MailDelivery',
		components: {
			ValidationProvider,
			ValidationObserver
		},
		computed: {
			deliveryMethod: {
				get () {
					return this.$store.state.deliveryMethod
				},
				set (value) {
					this.$store.commit('setDeliveryMethod', {deliveryMethod: value })
				}
			},
			deliveryFirstName: {
				get () {
					if (this.userAddress && this.userAddress.firstname) {
						return this.userAddress.firstname
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setFirstName', {deliveryFirstName: value })
				}
			},
			deliveryLastName: {
				get () {
					if (this.userAddress && this.userAddress.lastname) {
						return this.userAddress.lastname
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setLastName', {deliveryLastName: value })
				}
			},
			deliveryCompanyName: {
				get () {
					if (this.userAddress && this.userAddress.company) {
						return this.userAddress.company
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setCompanyName', {deliveryCompanyName: value })
				}
			},
			deliveryPhoneNumber: {
				get () {
					if (this.userAddress && this.userAddress.phone) {
						return this.userAddress.phone
					} else {
						return ''
					}

				},
				set (value) {
					this.$store.commit('setPhoneNumber', {deliveryPhoneNumber: value })
				}
			},
			deliveryStreet: {
				get () {
					if (this.userAddress && this.userAddress.street) {
						return this.userAddress.street
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setStreet', {deliveryStreet: value })
				}
			},
			deliveryStreetNumber: {
				get () {
					if (this.userAddress && this.userAddress.streetnumber) {
						return this.userAddress.streetnumber
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setStreetNumber', {deliveryStreetNumber: value })
				}
			},
			deliveryApartmentNumber: {
				get () {
					if (this.userAddress && this.userAddress.apartamentnumber) {
						return this.userAddress.apartamentnumber
					} else {
						return ''
					}

				},
				set (value) {
					this.$store.commit('setApartmentNumber', {deliveryApartmentNumber: value })
				}
			},
			deliveryZipCode: {
				get () {
					if (this.userAddress && this.userAddress.postcode) {
						return this.userAddress.postcode
					} else {
						return ''
					}

				},
				set (value) {
					this.$store.commit('setZipCode', {deliveryZipCode: value })
				}
			},
			deliveryCity: {
				get () {
					if (this.userAddress && this.userAddress.city) {
						return this.userAddress.city
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setCity', {deliveryCity: value })
				}
			},
			deliveryCountry: {
				get () {
					if (this.userAddress && this.userAddress.country) {
						return this.userAddress.country
					} else {
						return ''
					}
				},
				set (value) {
					this.$store.commit('setCountry', {deliveryCountry: value })
				}
			},
			...mapGetters({
				userAddress: 'GET_USER_ADDRESS',
                selectedPlan: 'GET_SELECTED_PLAN'
			})
		},
		methods: {
			onSubmit() {
                const period = this.selectedPlan.period_months == 12 ? 'r' : (this.selectedPlan.period_months == 1 ? 'm' : 'i');

                let item_categories = {
                    subscription: {
                        r: 'Prenumerata roczna',
                        m: 'Prenumerata miesięczna',
                        i: 'Prenumerata inna'
                    },
                    access: {
                        r: 'Dostęp roczny',
                        m: 'Dostęp miesięczny',
                        i: 'Dostęp inny'
                    },
                    chain: {
                        subscription: 'Prenumerata odawialna',
                        access: 'Dostęp odnawialny'
                    }
                };

                let item_category = '';

                switch (this.selectedPlan.post_type) {
                    case 'subscription_plan':
                        item_category = this.selectedPlan.is_shipping ?
                                item_categories.subscription[period] :
                                item_categories.access[period];
                        break;
                    case 'subscription_chain':
                        item_category = this.selectedPlan.is_shipping ?
                                item_categories.chain.subscription :
                                item_categories.chain.access;
                        break;
                    case 'coupon_gift':
                        item_category = this.selectedPlan.is_shipping ?
                                item_categories.subscription[period] :
                                item_categories.access[period];
                }

                const vm = this;
                this.$gtm.trackEvent({
                    event: 'add_shipping_info',
                    category: 'prenumerata',
                    action: 'click',
                    label: this.selectedPlan.title,
                    value: this.selectedPlan.price,
                    ecommerce: {
                        shipping_tier: 'Poczta Polska',
                        items: [{
                            item_category: item_category,
                            item_name: this.selectedPlan.title,
                            item_id: this.selectedPlan.ID,
                            price: this.selectedPlan.price,
                            item_variant: 'Dla siebie', // zawsze dla siebie kiedy wpisywane sa dane
                            promotion_id: '',
                            promotion_name: ''
                        }]
                    }
                });
				this.$store.commit('saveUserInSession');
				this.nextStep();
			},
			nextStep() {
				this.$store.commit('setActiveStep', { activeStep: 'SummaryStep' });
			}
		}
	}
</script>

<style scoped>

</style>
